export const romeDay = (d = new Date()) => d.toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" });
export const shiftDay = (iso, n) => { const d = new Date(`${iso}T12:00:00Z`); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };

export const payKind = (m) => {
  const s = (m || "").toLowerCase();
  if (/contant|cash/.test(s)) return "cash";
  if (/pos|carta|card|bancomat|satispay|sumup/.test(s)) return "pos";
  return "other";
};

// Regola della pagina Incassi: prenotazioni "Incassato" (data servizio) + pagamenti non collegati a prenotazioni Incassato.
// I pagamenti arrivano gi\u00e0 senza storni; esclusi i pagamenti a fornitori (come il report).
export function incomeEntries(bookings, payments) {
  const paid = bookings.filter(b => b.payment_status === "Incassato" && b.status !== "Cancellata");
  const ids = new Set(paid.map(b => b.id));
  return [
    ...paid.map(b => ({ date: b.date || "", amount: Number(b.price || 0), kind: payKind(b.payment_method) })),
    ...payments.filter(p => p.type !== "supplier" && !(p.booking_id && ids.has(p.booking_id)))
      .map(p => ({ date: p.date || "", amount: Number(p.amount || 0), kind: payKind(p.method) })),
  ];
}

export function sumBy(entries, pred) {
  const r = { cash: 0, pos: 0, other: 0, total: 0 };
  entries.forEach(e => { if (pred(e.date)) { r[e.kind] += e.amount; r.total += e.amount; } });
  return r;
}

export const STATUS_TONE = {
  Completata: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  "In corso": "bg-sky-500/15 text-sky-300 border-sky-500/40",
  Confermata: "bg-[#D4A72C]/15 text-[#F1D27A] border-[#D4A72C]/45",
  Assegnata: "bg-[#D4A72C]/15 text-[#F1D27A] border-[#D4A72C]/45",
  Preventivo: "bg-white/5 text-slate-300 border-white/15",
  "No show": "bg-rose-500/10 text-rose-300 border-rose-500/30",
  Cancellata: "bg-rose-500/10 text-rose-300/80 border-rose-500/25",
};
